import { render, staticRenderFns } from "./work-order.vue?vue&type=template&id=21b8bd44"
import script from "./work-order.vue?vue&type=script&lang=js"
export * from "./work-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports